export const FONTS = [
  {
    label: 'Inter',
    value: 'Inter',
    category: 'sans-serif',
    importUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'
  },
  {
    label: 'DM Sans',
    value: 'DM Sans',
    category: 'sans-serif',
    importUrl: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap'
  },
  {
    label: 'Poppins',
    value: 'Poppins',
    category: 'sans-serif',
    importUrl: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap'
  },
  {
    label: 'Playfair Display',
    value: 'Playfair Display',
    category: 'serif',
    importUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap'
  },
  {
    label: 'DM Serif Display',
    value: 'DM Serif Display',
    category: 'serif',
    importUrl: 'https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&display=swap'
  },
  {
    label: 'Cormorant Garamond',
    value: 'Cormorant Garamond',
    category: 'serif',
    importUrl: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&display=swap'
  },
]

export function getFontImports(fontNames = []) {
  const seen = new Set()
  return fontNames
    .map(name => FONTS.find(f => f.value === name))
    .filter(f => f && !seen.has(f.value) && seen.add(f.value))
    .map(f => `@import url('${f.importUrl}');`)
    .join('\n')
}
